// extracted by mini-css-extract-plugin
export var brand = "_40-9";
export var button = "_40-0";
export var chevron = "_40-v";
export var chevronButton = "_40-w";
export var content = "_40-n";
export var danger = "_40-g";
export var dangerOutlined = "_40-h";
export var dark = "_40-l";
export var darkTheme = "_40-c";
export var extraSmall = "_40-4";
export var fullWidth = "_40-8";
export var ghost = "_40-d";
export var gray = "_40-t";
export var icon = "_40-p";
export var iconButton = "_40-s";
export var iconButtonBorder = "_40-x";
export var iconButtonBorderDark = "_40-y";
export var iconButtonBorderLight = "_40-z";
export var iconLeft = "_40-q";
export var iconRight = "_40-r";
export var large = "_40-1";
export var light = "_40-m";
export var medium = "_40-2";
export var micro = "_40-5";
export var nano = "_40-7";
export var outlined = "_40-k";
export var pending = "_40-a";
export var primary = "_40-i";
export var shadow = "_40-o";
export var small = "_40-3";
export var solidLight = "_40-e";
export var solidLightBrand = "_40-f";
export var spinner = "_40-u";
export var transparent = "_40-j";
export var warning = "_40-b";
export var wideNano = "_40-6";